import { autoinject, customAttribute } from 'aurelia-framework';
import { ToggleableAttribute } from 'framework/aurelia_tools/toggleable-attribute';

@autoinject
@customAttribute('af-autogrow')
export class AutogrowCustomAttribute extends ToggleableAttribute {
  private element: HTMLTextAreaElement;
  valueBinding = null;

  constructor(element: Element) {
    super();
    this.element = element as HTMLTextAreaElement;
  }

  created(owningView) {
    this.valueBinding = owningView.bindings.find(b => b.target === this.element && b.targetProperty === 'value');
  }

  enabled() {
    this.element.classList.add(CLASS_COMPONENT);
    this.applyRules();
    this.valueBinding
      ? this.valueBinding.targetObserver.subscribe(this.applyRules)
      : this.element.addEventListener('input', this.applyRules);
  }

  disabled() {
    this.valueBinding
      ? this.valueBinding.targetObserver.unsubscribe(this.applyRules)
      : this.element.removeEventListener('input', this.applyRules);
    this.element.classList.remove(CLASS_COMPONENT);
  }

  applyRules = () => {
    this.element.style.height = '';
    this.element.style.height = `${this.element.scrollHeight + this.element.offsetHeight - this.element.clientHeight}px`;
  }
}

const CLASS_COMPONENT = 'af-autogrow';
